module.exports = __webpack_public_path__ + "img/Ellipse 4.8c26b77b.svg";